import React, { useCallback, useMemo } from 'react';
import { useFormikContext } from "formik";
import { SelectField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { useTypes } from "../contexts/types-context";
import { defaultTaskFormValues, fieldTypes } from "../constants";
import { useTemplateSynchronization } from '../hooks';

const TaskTypeField = React.memo(() => {
  const taskTypes = useTypes();
  const { setFieldValue } = useFormikContext();

  const handleChange = useCallback(() => {
    setFieldValue(fieldTypes.TASK_NAME, defaultTaskFormValues[fieldTypes.TASK_NAME]);
  }, [setFieldValue]);

  useTemplateSynchronization();

  const options = useMemo(() => {
    return Object.values(taskTypes).map((type) => ({
      value: type,
      label: translate(null, "care_team_tasks.types", type.replace("TASKTYPE_", "")),
    }));
  }, [taskTypes]);

  return (
    <SelectField
      name={fieldTypes.TASK_TYPE}
      options={options}
      onChange={handleChange}
      className="task-type-field"
      label={translate(null, "care_team_tasks.form.fields.task_type", "label")}
      placeholder={translate(null, "care_team_tasks.form.fields.task_type", "placeholder")}
    />
  );
});

export default TaskTypeField;
